module.exports = __webpack_public_path__ + "static/img/store-icon4.64d831b.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon4.png
// module id = S7p+
// module chunks = 1